<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <ng-container *notInPopulation="[population.Kids]">
        <img alt="" class="home-logo" [src]="'logos/nav-logo.png' | contentAssetImage" draggable="false" />
      </ng-container>
      <ng-container *inPopulation="[population.Kids]">
        <img alt="" class="home-logo" [src]="'logos/kids-logo.png' | contentAssetImage" draggable="false" />
      </ng-container>
    </a>
    <div class="d-flex justify-content-center align-items-center">
      <a class="nav-item me-2">
        <fgb-notification-button></fgb-notification-button>
      </a>

      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content my-2">
      <!-- Close Button -->
      <button
        class="close-button position-absolute border-0"
        attr.aria-label="{{ 'modal.close' | translate }}"
        (click)="isCollapsed = !isCollapsed"
      >
        <i class="material-icons close-btn text-white">close</i>
      </button>
      <div>
        <ng-container *notInPopulation="[population.Kids]">
          <img alt="" class="logo px-2" [src]="'logos/nav-logo.png' | contentAssetImage" draggable="false" />
        </ng-container>
        <ng-container *inPopulation="[population.Kids]">
          <img alt="" class="logo px-2" [src]="'logos/kids-logo.png' | contentAssetImage" draggable="false" />
        </ng-container>
      </div>
      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container mt-2">
        <ng-container *notInPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> account_circle </span>
            <div class="nav-text fw-bold">{{ 'nav.account' | translate }}</div>
          </a>
        </ng-container>
        <ng-container *inPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/activity']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> account_circle </span>
            <div class="nav-text fw-bold">{{ 'nav.activity' | translate }}</div>
          </a>
        </ng-container>

        <ng-container *notInPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/hawksbucks']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> payments </span>
            <div class="nav-text fw-bold">{{ 'nav.hawksbucks' | translate }}</div>
          </a>
        </ng-container>

        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined"> account_balance_wallet </span>
          <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
        </a>

        <ng-container *notInPopulation="[population.Kids]">
          <a class="nav-item" href="{{ 'nav.membership.url' | translate }}">
            <span class="material-symbols-outlined"> account_tree </span>
            <div class="nav-text fw-bold">{{ 'nav.membership' | translate }}</div>
          </a>
        </ng-container>

        <a
          class="nav-item"
          [routerLink]="['/rewards/marketplace']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined"> redeem </span>
          <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span class="material-symbols-outlined"> trophy </span>
          <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
        </a>

        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <span class="material-symbols-outlined"> sports_esports </span>
          <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
        </a>

        <ng-container *notInPopulation="[population.Kids]">
          <a class="nav-item" [routerLink]="['/guardians']" [routerLinkActive]="'active'">
            <span class="material-symbols-outlined"> child_care </span>
            <div class="nav-text fw-bold">{{ 'nav.kids' | translate }}</div>
          </a>
        </ng-container>

        <ng-container *notInPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/payment']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> credit_card </span>
            <div class="nav-text fw-bold">{{ 'nav.payment' | translate }}</div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[population.Kids]">
          <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <span class="material-symbols-outlined"> loyalty </span>
            <div class="nav-text fw-bold">{{ 'nav.earn' | translate }}</div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/gallery']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> animated_images </span>
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/worksheets']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> tactic </span>
            <div class="nav-text fw-bold">{{ 'nav.worksheets' | translate }}</div>
          </a>

          <a class="nav-item" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <span class="material-symbols-outlined"> sports_basketball </span>
            <div class="nav-text fw-bold">{{ 'nav.basketball.academy' | translate }}</div>
          </a>
        </ng-container>

        <div class="help-wrapper w-100">
          <div class="nav-item help-dropdown" (click)="toggleMenu()">
            <span class="material-symbols-outlined">info</span>
            <span class="nav-text">{{ 'nav.help' | translate }}</span>
            <span class="material-symbols-outlined arrow" [ngClass]="{ open: isMenuOpen }">expand_more</span>
          </div>

          @if (isMenuOpen) {
            <div class="help-submenu">
              <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" [routerLink]="['/faq']">
                {{ 'nav.faq' | translate }}
              </a>
              <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" href="{{ 'nav.contact.url' | translate }}">
                {{ 'nav.contact.us' | translate }}
              </a>
              <ng-container *inPopulation="[population.Kids]">
                <a class="right-nav-sub-item fw-bold" data-bs-dismiss="offcanvas" [routerLink]="['/terms']">
                  {{ 'nav.terms' | translate }}
                </a>
              </ng-container>
            </div>
          }
        </div>

        <ng-container *notInPopulation="[population.Kids]">
          <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <span class="material-symbols-outlined"> loyalty </span>
            <div class="nav-text fw-bold">{{ 'nav.earn' | translate }}</div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/my-renewals']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined"> cycle </span>
            <div class="nav-text fw-bold">{{ 'nav.renewals' | translate }}</div>
          </a>

          <a class="nav-item" href="{{ 'nav.shop.url' | translate }}">
            <span class="material-symbols-outlined"> local_mall </span>
            <div class="nav-text fw-bold">{{ 'nav.shop' | translate }}</div>
          </a>

          <a class="nav-item logout-link-div border" (click)="logout()">
            <span class="material-symbols-outlined"> logout </span>
            <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[population.Kids]">
          <div class="container">
            <div class="w-100">
              <fgb-back-to-guardian></fgb-back-to-guardian>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #accordionNav let-children="children" let-icon="icon" let-navTitle="navTitle">
  <div ngbAccordion class="nav-item-title-div w-100">
    <div ngbAccordionItem [collapsed]="true" class="w-100">
      <h2 ngbAccordionHeader class="mt-0">
        <button ngbAccordionButton data-testid="accordion-button" class="w-100 nav-title">
          <span class="icon material-icons me-2" aria-hidden="true">{{ icon }}</span>
          <span class="text-uppercase"> {{ navTitle | translate }}</span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ng-container *ngFor="let child of children">
              <ng-container *ngIf="child?.externalLink">
                <a class="nav-child" [innerHTML]="child.link | translate | markdownTranslate"> </a>
              </ng-container>
              <ng-container *ngIf="!child?.externalLink">
                <a
                  class="nav-child"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="child.link"
                  >{{ child.title | translate }}</a
                >
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
